export const DIRECT_SAVE_CLAIM_OPTIONS = [{ label: 'WALMAN OPTICAL', value: 'WALMAN OPTICAL' }]

export const isDirectSaveClaimOrg = (subdomain) => (
  subdomain === 'advancedeyeofmarietta' ||
  subdomain === 'infocuseyecare'
)
